import { marginBottom, marginTop, typography } from "../../styles";
import styled from "styled-components";
export const StepTitle = styled.h1`
  ${typography.title}
  color: ${({
  theme
}) => theme.brand.cssVars["--d-text"]};
  text-align: center;
  ${marginTop.zero}
  ${marginBottom.m}
  &::first-letter {
    text-transform: capitalize;
  }
`;
export default StepTitle;